import React from 'react';
import { FlatList, Text, View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { isBlank } from '../../utils/BooleanUtility';
import RoutineCommonActivities from './RoutineCommonActivities';


const RoutineVerticalList = (props) => {
  const { itemData = [], myRewardPoints = '', isRoutineActive } = props;
  const renderItem = ({ item }) => {
    if (isBlank(item)) return null;
    const { activity = {}, activityType = '' } = item;
    return <RoutineCommonActivities itemData={activity} activityType={activityType} myRewardPoints={myRewardPoints} isRoutineActive={isRoutineActive} />;
  };

  const keyExtractor = (item, index) => `${item.id}_${index}routine_vertical_list`;

  return (
    <FlatList
      data={itemData}
      keyExtractor={keyExtractor}
      renderItem={renderItem}
      contentContainerStyle={styles.listContainer}
    />
  );
};

const styles = StyleSheet.create({
  listContainer: {
    padding: 16,
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    padding: 10,
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  image: {
    width: 60,
    height: 60,
    borderRadius: 8,
    marginRight: 10,
  },
  textContainer: {
    flex: 1,
  },
  title: {
    fontSize: 16,
    color: '#333',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: 14,
    color: '#666',
  },
});

export default RoutineVerticalList;
